import type { IUpdateMemberRole } from '@escloud/types';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { useApi } from '@/context';

export const memberKeys = {
    all: ['members'] as const,
    list: (tenantId: string) => [...memberKeys.all, tenantId] as const,
};

export function useMembers(tenantId: string | undefined) {
    const api = useApi();

    return useQuery({
        queryKey: memberKeys.list(tenantId!),
        queryFn: () => api.tenants.getMembers(tenantId!),
        enabled: !!tenantId,
    });
}

export function useUpdateMemberRole(tenantId: string) {
    const api = useApi();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ userId, data }: { userId: string; data: IUpdateMemberRole }) =>
            api.tenants.updateMemberRole(tenantId, userId, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memberKeys.list(tenantId) });
        },
    });
}

export function useRemoveMember(tenantId: string) {
    const api = useApi();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (userId: string) => api.tenants.removeMember(tenantId, userId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memberKeys.list(tenantId) });
        },
    });
}
